import React from 'react';
import './copyrights.css';

const Copyrights = () => {
    return ( 
        <>
        <article className='copyrights'>
            <p>Copyright © Alliance Law 2026.</p>
            <a href="#footer">Privacy Policy</a>
        </article>
        </>
     );
}
 
export default Copyrights;